//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Q_Tc',
  data() {
    return {
      form: {
        qt: '',
        rr: ''
      },
      res: '',
      res1: '',
      hasScore: false,
      disabled: false,
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.res = form.qt / Math.pow(form.rr, 1 / 2)
        self.res1 = form.qt / Math.pow(form.rr, 1 / 3)
        self.res = self.res.toFixed(2)
        self.res1 = self.res1.toFixed(2)
        self.hasScore = true
        return String(self.res, self.res1)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Q_Tc.vue